import { post } from 'lib/request';

export const postCompanyInterest = async ({
  company,
  email,
  message,
  name,
  phone,
}) => {
  const body = { name, email };

  if (phone) {
    body.phone = phone;
  }

  if (company) {
    body.company = company;
  }

  if (message) {
    body.message = message;
  }

  return post('/v4/mails/send-contact', { body });
};
